import type {BoxProps} from '@tempo/core';
import {IFrame} from './Iframe';

export type YoutubeProps = BoxProps & {
	videoId: string;
	controls?: boolean;
	title?: string;
};
export const Youtube: React.FC<YoutubeProps> = ({
	videoId,
	controls,
	title = 'YouTube video player',
	...boxProps
}) => {
	return (
		<IFrame
			loading="lazy"
			m={2}
			width={{base: '300px', md: '740px', sm: '520px'}}
			height={{base: '186px', md: '460px', sm: '323px'}}
			src={`https://www.youtube.com/embed/${videoId}?controls=${controls ? '1' : '0'}`}
			title={title}
			frameBorder="0"
			allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
			allowFullScreen
			{...boxProps}
		/>
	);
};
